export default __webpack_public_path__ + "static/media/bg-1.4f0f8b6d.jpg";